import React, {ReactElement, useEffect, useMemo, useState} from 'react'
import {
  Table,
  TableHead,
  TableBody,
  Search,
  DateRange,
  StatusText,
  PanelHeader,
  PanelPopover,
  Panel, RightBigPanel, RightBigPanelHeader
} from '../../../../shared'
import {useAppDispatch, useAppSelector} from '../../../../core/hooks'
import {getActiveTickets, handleFilterChange, loadMoreData} from '../active-tickets-slice'
import './er-active-tickets.scss'
import {
  setData,
  toggleEditRequest,
  toggleMainPanel,
  togglePopover,
  toggleRightMainPanel
} from '../../../../app/app-slice'
import {getCustomerSentrySingleRequests, getErSingleRequest} from '../../../requests/er-thunk'
import {
  ACTIVE_TICKETS_HEAD, ACTIVE_TICKETS_HEAD_EMERGENCY_DC,
  ACTIVE_TICKETS_STATUS_NAMES,
  ER_CALL_STATUS_FILTER, ER_HISTORY_HEAD,
  ER_HISTORY_HEAD_DC
} from '../../table-constants'
import styles from "../../styles.module.scss";
import {debounce} from 'lodash'
import Header from "../../../er-request/header";
import Content from "../../../er-request/content";
import {EditBrigadeForm} from "../../../er-request/components";
import moment, {Moment} from 'moment'
import {CSVLink} from "react-csv";
import {ExcelIcon, ExportIcon} from "../../../../assets"
import {useHistory} from "react-router-dom";
import {Autocomplete, Button, Input} from "../../../../ui-components";
import { ExportToExcel } from '../../exportToExcel'
import DpContent from "../../../sentry/DpComponents/DpContent";
import ScheduledContent from "../../../scheduledCall/ScheduledContent";
import ErDpHeader from "../../../er-request/header";
import RequestForm from "../../../requests/request-form";

const ErActiveTickets = () => {
  const dispatch = useAppDispatch()
  const {activeTicketsEmergency, filter, allDataLoaded} = useAppSelector(state => state.activeTicketsEmergency)
  const app = useAppSelector(state => state.app)
  const {user} = useAppSelector(state => state.user)
  const [selectedModalBrigade, setSelectedModalBrigade] = useState<string>("")

  const history = useHistory()
    const today = moment().utc().endOf('day')
  const initialRange = moment().subtract(30, 'days').utc().startOf('day')
  useEffect(()=>{
    document.body.classList.add('scrollable')
    return ()=>{
      document.body.classList.remove('scrollable')
    }
  }, [])
  useEffect(() => {
    dispatch(setData({prop: 'pageTitle', data: 'В исполнении'}))
    dispatch(filterChange('from', initialRange))
    dispatch(filterChange('to', today))
    dispatch(getActiveTickets())
  }, [dispatch, history.location])

  const debouncedChangeHandler = useMemo(
    () => debounce(() => dispatch(getActiveTickets()), 700),
    [dispatch]
  );

  const filterChange = (key: string, value: any) => dispatch(handleFilterChange({key, value}))

  const loadMore = () => {
    const offset = filter.offset as number
    const limit = filter.limit as number
    dispatch(filterChange('offset', offset + limit))
    dispatch(loadMoreData())
  }
  const isDc = user && user.role === 5

  const setStatusText = (status): ReactElement => {
    let statusText: any = ''
    switch (status) {
      case 1:
        statusText = <StatusText color={'blue'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 2:
        statusText = <StatusText color={'blue'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 3:
        statusText = <StatusText color={'orange'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 4:
        statusText = <StatusText color={'green'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 7:
        statusText = <StatusText color={'blue'} text='Ожидает подтверждения'/>
        break
      case 8:
        statusText = <StatusText color={'blue'} text='Ожидает подтверждения'/>
        break
      case 9:
        statusText = <StatusText color={'green'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 10:
        statusText = <StatusText color={'blue'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 11:
        statusText = <StatusText color={'gray'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 13:
        statusText = <StatusText color={'orange'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 16:
        statusText = <StatusText color={'blue'} text={'Ожидает подтверждения'}/>
        break
      case 19:
        statusText = <StatusText color={'orange'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 20:
        statusText = <StatusText color={'orange'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
      case 21:
        statusText = <StatusText color={'orange'} text={ACTIVE_TICKETS_STATUS_NAMES[status - 1]}/>
        break
    }
    return statusText
  }

  const headers = [
    {label: "Номер карточки", key: "number"},
    {label: "ФИО", key: "name"},
    {label: "Д/В", key: "age"},
    {label: "Дата", key: "created_date"},
    {label: "Длительность прибытия", key: "arrival_time"},
    {label: "Жалобы", key: "complaints"},
    {label: "Результат", key: "status"},
    {label: "Название СК", key: "org_name"}
  ];


  const xlsxHeaders = [
    "Номер карточки",
    "ФИО",
    "Д/В",
    "Дата",
    "Длительность прибытия",
    "Жалобы",
    "Результат",
    "Название СК"
  ];

  const filtered = [] as any
  const csv = [] as any
  const xlsx = [] as any
  const uuids = [] as any
  const sentryGroupUuids = [] as any

  for (let ticket of activeTicketsEmergency) {
    uuids.push(ticket.request_uuid)
    sentryGroupUuids.push(ticket.sentry_group_uuid)

    filtered.push({
      number: ticket.number,
      name: ticket.name,
      age: ticket.age < 18 ? 'Д(0-18)' : 'В(18+)',
      created_date: moment(ticket.created_date).format('DD/MM/YYYY HH:mm'),
      arrival_time: `${ticket.arrival_time}`,
      complaints: ticket.complaints,
      status: setStatusText(ticket.status),
      org_name: ticket.org_name
    })
    csv.push({
      number: ticket.number,
      name: ticket.name || '',
      age: ticket.age < 18 ? 'Д(0-18)' : 'В(18+)',
      created_date: moment(ticket.created_date).format('DD/MM/YYYY HH:mm'),
      arrival_time: `${ticket.arrival_time}`,
      complaints: ticket.complaints || '',
      status: ACTIVE_TICKETS_STATUS_NAMES[ticket.status - 1],
      org_name: ticket.org_name
    })
    xlsx.push([
      ticket.number,
      ticket.name || '',
      ticket.age < 18 ? 'Д(0-18)' : 'В(18+)',
      moment(ticket.created_date).format('DD/MM/YYYY HH:mm'),
      `${ticket.arrival_time}`,
      ticket.complaints || '',
      ACTIVE_TICKETS_STATUS_NAMES[ticket.status - 1],
      ticket.org_name
    ])
  }

  const csvReport = {
    data: csv,
    headers: headers,
    filename: 'В исполнении.csv'
  };
  const erList = isDc ? ER_HISTORY_HEAD_DC : ER_HISTORY_HEAD

  const bodyRow = filtered.map((el, i) => Object.values(el))
  return (
    <div id={styles.activeTicketsList}>
      <div className={styles.filterHeader}>
        <Search handleChange={e => {
          filterChange('q', e.target.value)
          debouncedChangeHandler()
        }} value={filter.q as string}/>
        <div className={styles.filtersWrapper}>
          <DateRange
            handleFromChange={(date) => {
              dispatch(filterChange('from', moment(date).utc().startOf('d')))
              dispatch(getActiveTickets())
            }}
            handleToChange={(date) => {
              dispatch(filterChange('to', moment(date).add(1, 'd').utc().endOf('d')))
              dispatch(getActiveTickets())
            }}
            dateFrom={filter.from}
            dateTo={moment(filter.to).subtract(1, 'd').toString()}/>
          <Input label='Возраст'
                 className='ml-20'
                 onChange={e => {
                   filterChange('data[age]', e.target.value)
                   debouncedChangeHandler()
                 }} value={filter.data!.age}/>
          <Autocomplete label='Статус'
                        isClearable
                        onChange={(data) => {
                          dispatch(filterChange('data[status]', data.key))
                          dispatch(getActiveTickets())
                        }}
                        value={filter.data!.status}
                        className={`${styles.selectWrapper} ml-20 mr-20`}
                        options={ER_CALL_STATUS_FILTER}
                        optionLabel={'value'} optionValue={'key'}/>
          <CSVLink {...csvReport}><ExportIcon/></CSVLink>
          <div onClick={() => ExportToExcel(xlsx, 'В исполнении СМП', xlsxHeaders)}><ExcelIcon/></div>
        </div>
      </div>
      <Table className={'left-table-wrapper'}>
        <div className={'left-table-container fit-to-screen'}>
          <TableHead>
            {ACTIVE_TICKETS_HEAD_EMERGENCY_DC.map((el, i) => <div className={`${styles.item} item`} key={i}>{el}</div>)}
          </TableHead>
          <TableBody className='no-top-border'>
            {filtered.map((el, i) =>
              <div onClick={() => {
                if(user && user.organization.type === 4) {

                  dispatch(getCustomerSentrySingleRequests({uuid: uuids[i], sentry_group_uuid: sentryGroupUuids[i]}))
                  setSelectedModalBrigade(uuids[i])
                } else {
                  dispatch(getCustomerSentrySingleRequests({uuid: uuids[i], sentry_group_uuid: sentryGroupUuids[i]}))
                  dispatch(toggleMainPanel())
                }

              }}  key={i} className='row'>
                {
                  bodyRow[i].map((el, index) =>
                    <div key={index} className={`${styles.item} item`}>
                    <span title={el}>
                      {el}
                    </span>
                    </div>)
                }
              </div>
            )}
          </TableBody>
        </div>
      </Table>
      {!allDataLoaded && <Button onClick={loadMore} className={styles.loadMoreBtn}>Загрузить еще</Button>}

      {user && user.organization.type === 4 && <RightBigPanel handleClose={() => dispatch(toggleRightMainPanel())} open={app.rightMainPanel}>
        <RightBigPanelHeader>
          <Header isDc handleClose={() => dispatch(toggleRightMainPanel())}/>
        </RightBigPanelHeader>
        <ScheduledContent selectedModalBrigade={selectedModalBrigade}/>
      </RightBigPanel>}


      {user.role !== 5 &&<Panel handleClose={() => dispatch(toggleMainPanel())} open={app.mainPanelOpen}>
        <PanelHeader>
          <ErDpHeader handleClose={() => dispatch(toggleMainPanel())}/>
        </PanelHeader>
        <DpContent/>
        <PanelPopover open={app.popoverFormStatuses.editRequestOpen}
                      handleClose={() => dispatch(toggleEditRequest())}
                      title={'Изменить данные пациента'}>
          <RequestForm/>
        </PanelPopover>
      </Panel>}
    </div>
  )
}

export default ErActiveTickets
